import { Component, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { PosthogService } from './core/services/posthog/posthog.service';
import { SessionRepository } from './core/services/repositories/session.repository';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  #posthog = inject(PosthogService);
  #sessionRepository = inject(SessionRepository);

  constructor() {
    this.#posthog.initPostHog();

    effect(() => {
      const user = this.#sessionRepository.user();
      if (user) {
        this.#posthog.identify(user.id, { organization_id: user.organization.id });
      }
    });
  }
}
